import { render, staticRenderFns } from "./payment.vue?vue&type=template&id=6e1482cc&scoped=true"
import script from "./payment.vue?vue&type=script&lang=ts"
export * from "./payment.vue?vue&type=script&lang=ts"
import style0 from "./payment.vue?vue&type=style&index=0&id=6e1482cc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e1482cc",
  null
  
)

export default component.exports